import { useEffect, useState } from 'react';

/**
 * Debounce hook - returns a debounced value
 * @param value - value to debounce
 * @param delay - in milliseconds
 * @returns debounced value
 */
const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Update debounced value after delay
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      // Clear timeout if value changes or if component unmounts
      clearTimeout(timeoutId);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
